// extracted by mini-css-extract-plugin
export default {"icon":"WithTooltip_icon__paYda","left":"WithTooltip_left__18Y4x","right":"WithTooltip_right__Mg0A3","white":"WithTooltip_white__4dQJU"};